// Module
var code = "{{formatDate($parent.row.created_at)}}";
// Exports
module.exports = code;